import i18n from 'i18next'
import {
  CountryCode,
  ParseError,
  parsePhoneNumberWithError,
} from 'libphonenumber-js'
import { initReactI18next } from 'react-i18next'
import { en } from '~/locales/en'
import { en_CA } from '~/locales/en_ca'
import { en_GB } from '~/locales/en_gb'
import { ne } from '~/locales/ne'

const resources = {
  en: en,
  'en-GB': en_GB,
  'en-CA': en_CA,
  ne: ne,
}

const getPotentialCountryCode = (lng?: string): CountryCode | undefined => {
  if (lng) {
    const parts = lng.split(/[-_]/)
    if (parts.length > 1) {
      const potentialCountry = parts[parts.length - 1]

      if (potentialCountry.length === 2) {
        return potentialCountry.toUpperCase() as CountryCode
      }
    }

    if (lng.length === 2 && lng === lng.toUpperCase()) {
      return lng as CountryCode
    }
  }

  return undefined
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
      format: (value: any, format?: string, lng?: string) => {
        if (format === 'phone') {
          const defaultCountry = getPotentialCountryCode(lng)
          const stringValue = String(value)

          try {
            const phoneNumber = parsePhoneNumberWithError(stringValue, {
              defaultCountry,
            })

            return phoneNumber.formatInternational()
          } catch (error: any) {
            const contextCountry = defaultCountry || 'none'

            if (error instanceof ParseError) {
              console.error(
                `Phone number parsing error for "${stringValue}" (country context: ${contextCountry}): ${error.message}`,
              )
            } else if (error instanceof Error) {
              console.error(
                `Generic error formatting phone number "${stringValue}" (country context: ${contextCountry}): ${error.message}`,
              )
            } else {
              console.error(
                `Unknown error formatting phone number "${stringValue}" (country context: ${contextCountry}):`,
                error,
              )
            }
            return stringValue
          }
        }

        return String(value)
      },
    },
  })

export const i18nConfig = i18n
